export default {"src":"/_next/static/media/0x7ceb23fd6bc0add59e62ac25578270cff1b9f619.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};